import posthog from "posthog-js";

const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const host = import.meta.env.VITE_POSTHOG_HOST as string | undefined;

let initialized = false;

export function initAnalytics(): void {
  if (initialized || !key) return;
  posthog.init(key, {
    api_host: host ?? "https://eu.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
  });
  initialized = true;
}

export interface WebIdentifyTraits {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export function identify(userId: string, traits: WebIdentifyTraits): void {
  if (!initialized) return;
  posthog.identify(userId, {
    email: traits.email ?? undefined,
    $name:
      [traits.firstName, traits.lastName].filter(Boolean).join(" ") ||
      undefined,
  });
}

export function track(
  event: string,
  properties?: Record<string, unknown>,
): void {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export function reset(): void {
  if (!initialized) return;
  posthog.reset();
}
